import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const wrapper: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  justify-content: center;

  &:not:first-child {
    ${getSpacing.marginTop(theme, SpacingName.BIG)}
  }
`;
